<template>
  <div>
    <el-row class="center">
      <div v-for="(list, i) in list">
        <el-button
          type="primary"
          plain
          class="bt"
          @click="routerLinkTo(list.name,list.id)"
          >{{ list.name }}</el-button
        >
      </div>
    </el-row>
  </div>
</template>

<script>
import api from '@/utils/api'
export default {
  props: {
    list: {
        type: Array,
        default: null
    }
  },
  name: 'NewsBar',
  data() {
    return {
      title: '',
    }
  },
  methods: {
    routerLinkTo(e,id) {
      console.log(id)
      this.$router.push({
        path: '/services/servicesList',
        query: {
          title_name: e,
          category: id
        },
      })
    },
  },
}
</script>

<style scoped>
/* 按钮之间的距离 按钮内部样式*/
/deep/ .bt {
  margin-top: 2rem;
  height: 5.625rem;
  width: 43.875rem;
  font-size: 1.875rem;
  color: #0099da !important;
  border-radius: 0.5rem;
}
/deep/ .el-button {
  background: -webkit-gradient(
    linear,
    100% 0%,
    0% 0%,
    from(#e9f4ff),
    to(#ffffff)
  ) !important;
  color: #fff;
}
/* 按钮组件距离tabs栏的距离和位置center */
.center {
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 6.25rem;
}
</style>
